import { useIntl } from '@/intl'
import { Sheet, Typography } from '@sunwebgroup/ui-components/uds'
import { useGroupResponsibleStore } from '../../infrastructure/useGroupResponsibleStore'

export function EditSheetPortal() {
  const intl = useIntl()
  const isEditingParticipants = useGroupResponsibleStore(state => state.isEditingParticipants)
  const toggleIsEditingParticipants = useGroupResponsibleStore(state => state.toggleIsEditingParticipants)

  return (
    <Sheet.Root open={isEditingParticipants} onOpenChange={open => toggleIsEditingParticipants(open)}>
      <Sheet.Body side="right" hasPadding bottomSideInMobile={false}>
        <Sheet.Header
          closeLabel={intl.formatMessage({ id: 'close' })}
          titleLabel={intl.formatMessage({ id: 'groups_responsible_edit_text' })}
        />
        <Sheet.Content>
          <Typography>
            TODO: Implement the editing functionality here
          </Typography>
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}
